import React from 'react';
import '../../css/table.css';
import language from '../../variables/language';
import Icon from './Icon';
 import { DateTime } from "luxon";
 const TrMessages = ({ headers, item ,btr, td , onRefreshHundler, stateHundler,label, props}) => {
  

  var nextId = 0;
  var fromId = 0;
  let counter = 0;

  const getFoldedData = (folders, item) => {
    
    let obj = item;
    let result = '';
    for(let folder of folders) {
      if(obj[folder] && obj[folder] instanceof Object) {
        obj = obj[folder]
      } else {
        result = obj[folder];
        break;
      }
    }
    return result;
  }


  const formattData = (value) => {
    if (!value || value == 0 || value === '0') {
      return '';
    } else {
      return value;
    }
  } 

  const getStraightData = (headerConfig, header, item, concatenatedNames) => {
    if (header === 'dateTime') {
        return  DateTime.fromISO(item[headerConfig.name || header], { setZone: true }).toFormat("dd.MM.yyyy HH:mm:ss")
    }

    if (header === 'isBot' && item[header] === 1) {
      return concatenatedNames;
    }

    if (header === 'isBot' && item[header] === 0) {
      return 'User';
    }

    if (header && item[header]) {
      return formattData( language[language.lang][item[header]] || item[header]) ; 
    }

    return ''
    
  }


   return (
    
     <tr  className={btr} key={item.id}>
       {Object.keys(headers).map(header => {
       let concatenatedNames = '';
       let styles = {
        marginBlock: 0,paddingBlock:0,
      };
      let divStyles = {
        marginBlock: 5,paddingBlock:10,
      };
       counter++;
  
       if(header === 'isBot'){
      
        if(item['isBot'] === 1){
          styles.borderLeft=`3px solid #4e71a3ff`;
          if(item?.outerUser?.name){
            concatenatedNames +='Bot';// "item['outerUser']['name']";
          }else{
            if(item.conversationProgressId?.meta){
              concatenatedNames += 'Bot';// item.conversationProgressId.meta.split("-")[0];
            }else{
              concatenatedNames = 'empty';
            }
          }
        }else{
          concatenatedNames += 'User';
         // styles.filter = 'hue-rotate(158deg)';
          styles.scale="0.97";
          styles.paddingLeft = '20px'
          styles.borderLeft=`3px solid #cac143ff`;

        }
       }
        if(header === 'text'&& item['isBot'] === 0 && counter===2){
          divStyles.border = `1px solid #aba358ff`;
          divStyles.color='#c659fdff';
          styles.paddingLeft = '20px'
          divStyles.borderRadius = `20px 0px 20px 20px`
         } 
        if(header === 'text'&& item['isBot'] === 1 && counter===2){
          divStyles.border = `1px solid #579aaeff`;
         } 
    


       
        return(
         <td className={td} key={header+counter} style={styles}>
               <div style={divStyles} className='txt-c-secon table-buttons-container' data-label={language[language.lang][header]} >
               <p style={{paddingInline:10}}> { 
                  headers[header] && headers[header].folders 
                  ?
                  (language[language.lang][getFoldedData(headers[header].folders , item)] || getFoldedData(headers[header].folders , item))
                    :
                   getStraightData (headers[header], header, item, concatenatedNames)

                }</p>
                {  headers.icons === headers[header]? Object.keys(headers[header]).map(icon => (
                  <Icon label={label} key={headers[header][icon].name+'-'+item.id}  item={item} headers={headers[header][icon]}
                  mode={headers[header][icon].mode} headerParams={headers[header][icon]} stateHundler={stateHundler}  clearurl={headers[header][icon].url}
                  className={headers[header][icon].name} classes={headers[header][icon].class} url={headers[header][icon].url +'/'+ item['id']} 
                  id={ headers?.[header]?.[icon]?.mode === 'nextedit' ? ( item?.nextId?.id ? nextId : item.id ) :  (headers?.[header]?.[icon]?.mode === 'fromedit' && item?.fromId?.id ? fromId : item.id )} data-label=''
                   onRefreshHundler={onRefreshHundler} /> )) 
                  : ''}
                  
                </div>
               

         </td>
        );
         
    })}
       
     </tr>
   );
 };
 export default TrMessages;